import React from "react";
import useIsMobile from "./hooks/useIsMobile";

export default function WaveDivider({ style = {} }) {
  const isMobile = useIsMobile();
  return (
    <div style={{ width: "100%", overflow: "hidden", lineHeight: 0, ...style }}>
      <img
        src="/wave-divider.svg"
        width={1200}
        height={90}
        alt=""
        // width/height = viewBox des SVG → Browser reserviert den Platz vor dem Laden (kein Layout-Shift)
        style={{ width: "100%", height: "auto", minHeight: isMobile ? 18 : 30, maxHeight: isMobile ? 28 : undefined, display: "block" }}
        draggable={false}
      />
    </div>
  );
}
